import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  ButtonPrimary,
  Input,
  CardActionable,
  IconAttach,
  IconTrash,
} from '@americanexpress/dls-react';
import '../../style/common.css';
import * as stringConstants from '../../constants/stringConstants';

const AttachFiles = (props) => {
  const maxSize = props.maxSize ?? 3000000;
  const maxTotalSize = props.maxTotalSize ?? 10000000;
  const inputFiles = useRef(props.files);
  const [placeHolder, setPlaceHolder] = useState(
    stringConstants.ATTACHMENT_DEFAULT_PLACEHOLDER
  );
  const [validationError, setValidationError] = useState('');

  useEffect(() => {
    setPlaceHolderText(props.files?.files?.length ?? 0);
  }, []);

  const handleOldDocDelete = (index, docGuid) => {
    const updatedDocs = props.uploadedDocs;
    updatedDocs.splice(index, 1);
    props.setUploadedDocs(updatedDocs);
    props.setDeletedDocGuids(oldArray =>
      [...oldArray, docGuid]
    );
  }

  const handleAlreadyAttachedFilesDelete = (index) => {
    const filesToDelete = props.alreadyAttachedFiles;
    filesToDelete.files.splice(index, 1);
    props.setAlreadyAttachedFiles({
      ...props.alreadyAttachedFiles,
      files: filesToDelete.files,
    });
    setPlaceHolderText(filesToDelete.files.length);
  };

  const handleDelete = (index) => {
    const filesToDelete = props.files;
    filesToDelete.files.splice(index, 1);
    props.setFiles({
      ...props.files,
      files: filesToDelete.files,
    });
    setPlaceHolderText(filesToDelete.files.length);
  };
  const validateFileSize = (files) => {
    let isValid = true;
    let totalSize = 0;
    Array.from(files).forEach((file) => {
      totalSize += file.size;
      if (file.size > maxSize) {
        isValid = false;
      }
    });
    if (totalSize > maxTotalSize) {
      isValid = false;
    }

    return isValid;
  };

  const validateFileType = (files) => {
    let isValid = true;
    Array.from(files).forEach((file) => {
      if (file.type !== 'application/pdf') {
        isValid = false;
      }
    });

    return isValid;
  };

  const setPlaceHolderText = (fileCount) => {
    let placeHolderText = stringConstants.ATTACHMENT_DEFAULT_PLACEHOLDER;
    if (fileCount === 0) {
      setPlaceHolder(placeHolderText);
      return;
    }

    placeHolderText =
      fileCount > 1
        ? `${fileCount} files uploaded!`
        : `${fileCount} file uploaded!`;
    setPlaceHolder(placeHolderText);
  };

  const handleFileChange = (event) => {
    if (!validateFileType(event.target?.files)) {
      setValidationError(
        `Please select pdf files only`
      );
      return;
    }

    if (!validateFileSize(event.target?.files)) {
      const maxSizeInMb = parseInt(maxSize / 1000000);
      const maxTotalSizeInMb = parseInt(maxTotalSize / 1000000);
      setValidationError(
        `Please select files which are below ${maxSizeInMb}MB & total size should not exceed ${maxTotalSizeInMb}MB`
      );
    } else {
      setValidationError('');
      props.setFiles({
        ...props.files,
        files: [...props.files.files ?? [], ...Array.from(event.target.files)],
      });
      const fileCount = (props.files.files?.length ?? 0) + event.target.files.length;
      setPlaceHolderText(fileCount);
    }
  };

  const onBrowseClick = () => inputFiles.current.click();

  const attachedFiles =
    props.files?.files?.length > 0 || props.alreadyAttachedFiles?.files?.length > 0 || props.uploadedDocs?.length > 0 ? (
      <CardActionable className="flex margin-responsive margin-left-0 width-100">
        <div className="flex">
          <div className="pad-responsive-r">
            <IconAttach className="dls-bright-blue" size="lg" />
          </div>
          <div>
            <h4 className="heading-3 margin-1-b display-block dls-bright-blue">
              List of Attached Files
            </h4>
            {props.uploadedDocs?.length > 0 && <ul className="list-style-none heading-1">
              {props.uploadedDocs.map((doc, key) => (
                <div key={key}>
                  {doc.docName}
                  <IconTrash
                    onClick={() => handleOldDocDelete(key, doc.docGuid)}
                    className="margin-responsive"
                  />
                </div>
              ))}
            </ul>}
            <ul className="list-style-none heading-1">

              {props.alreadyAttachedFiles?.files?.length > 0 && Object.values(props.alreadyAttachedFiles.files).map((item, key) => (
                <div key={key}>
                  {item.name}
                  <IconTrash
                    onClick={() => handleAlreadyAttachedFilesDelete(key)}
                    className="margin-responsive"
                  />
                </div>
              ))}
            </ul>

            <ul className="list-style-none heading-1">

              {props.files?.files?.length > 0 && Object.values(props.files.files).map((item, key) => (
                <div key={key}>
                  {item.name}
                  <IconTrash
                    onClick={() => handleDelete(key)}
                    className="margin-responsive"
                  />
                </div>
              ))}
            </ul>
          </div>
        </div>
      </CardActionable>
    ) : (
      <div />
    );

  return (
    <div>
      <div className="flex min-width-100" id={props.id} onClick={onBrowseClick}>
        <Input
          size={100}
          value={placeHolder}
          disabled={true}
          ref={inputFiles}
        />
        <input
          className="display-none"
          type="file"
          ref={inputFiles}
          onChange={handleFileChange}
          disabled={props.isDisabled}
          multiple={props.isMultiple}
          accept="application/pdf"
        />
        <ButtonPrimary className="margin-auto-t">Browse</ButtonPrimary>
      </div>
      <p className="dls-red">{validationError}</p>
      {attachedFiles}
    </div>
  );
};

AttachFiles.propTypes = {
  placeHolder: PropTypes.string,
  onFileChange: PropTypes.func,
  id: PropTypes.string,
  isMultiple: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

export default AttachFiles;
